import { Trans } from "@lingui/react/macro"
import { Alert, Stack, Text } from "@mantine/core"
import { ImageProviderCard } from "../../ImageProviderCard"
import type { IProps } from "./interfaces"

export function ImageGenerationPanelView({
  settings,
  configuredSecrets,
  saving,
  isAdminOnly = false,
  canManage = true,
  refImageModels,
  updateSetting,
  saveKey,
}: IProps): React.JSX.Element {
  return (
    <Stack gap="md">
      <Alert variant="light" color="info">
        <Text size="sm">
          {isAdminOnly ? (
            <Trans>
              Configure image generation providers for visual content in meeting summaries. Platform keys are used as
              defaults; companies can supply their own keys (BYOK).
            </Trans>
          ) : (
            <Trans>
              Pick the image model used for visual content. Provider keys are managed by your platform administrator.
            </Trans>
          )}
        </Text>
      </Alert>
      <ImageProviderCard
        name="runware"
        label="Runware"
        settingKey="platform_runware_image_key"
        currentKey={settings.platform_runware_image_key ?? ""}
        configured={configuredSecrets.has("platform_runware_image_key")}
        onKeyChange={(v) => updateSetting("platform_runware_image_key", v)}
        onSave={() => saveKey("platform_runware_image_key")}
        saving={saving}
        // Platform Runware key is super-admin-only; tenants only pick the model.
        showKeyInput={isAdminOnly}
        modelDisabled={!canManage}
        models={refImageModels.filter((m) => m.provider === "runware")}
        currentModel={settings.image_model}
        onModelChange={(v) => {
          updateSetting("image_model", v)
          saveKey("image_model")
        }}
      />
    </Stack>
  )
}
